import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell';
import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import AddProduct from './AddProduct';
import {
  FILTER_EXPRESSION_OPERATOR,
  FILTER_OPERATOR,
  PRODUCTS_TYPE,
} from '../../../common/constants';
import {dateFormatFR, numberFormatThousands} from '../../../utils';
import ProductActions from './ProductActions';
import DisplayAmount from '../../../common/components/DisplayAmount';

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;


const GRAPHQL_QUERY_PRODUCTS = gql`
  query products($criteria: CriteriaInput!) {
    products(criteria: $criteria) {
      id
      rows{
        type
        id
        price
        quantity
        createdAt
        updatedAt
        description
      }
      total
    }
  }
`;

const initialFilters = {
  expressions: [{
    operator: FILTER_EXPRESSION_OPERATOR.And,
    filters: [{
      field: 'type',
      value: PRODUCTS_TYPE.NOTIFICATION,
    }],
  }],
};

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('pack'),
    accessor: 'description',
    sortable: true,
  },
  {
    Header: t('quantity'),
    Cell: ({cell}) => numberFormatThousands(cell.value),
    accessor: 'quantity',
    sortable: true,
  },
  {
    Header: t('price'),
    accessor: 'price',
    sortable: true,
    Cell: ({cell}) => <DisplayAmount amount={cell.value}/>,
  },
  {
    Header: t('createdAt'),
    accessor: 'createdAt',
    sortable: true,
    Cell: ({cell}) => dateFormatFR(cell.value),
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <ProductActions product={cell.value}/>,
    accessor: row => row,
  },
];

const ProductsView = ({t}) => {
  const [advancedFilters, setAdvancedFilters] = useState(initialFilters);

  const onSearch = search => setAdvancedFilters({
    ...initialFilters,
    expressions: [
      ...initialFilters.expressions,
      {
        operator: FILTER_EXPRESSION_OPERATOR.Or,
        filters: [{
          field: 'id',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        },{
          field: 'description',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        },{
          field: 'price',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'quantity',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        },
        ],
      }],
  });

  return (
    <Screen
      header={<Metadata meta={t('meta')} title={t('title')}/>}
      leftTitle={
        <>
          <FontAwesomeIcon icon={faBell} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('notifications')}</Span>
        </>
      }
      rightTitle={<AddProduct/>}
    >
      <DataTable
        query={GRAPHQL_QUERY_PRODUCTS}
        keyResult="products"
        columns={columns(t)}
        onSearch={onSearch}
        advancedFilters={advancedFilters}
        defaultSort={{field: 'createdAt'}}/>
    </Screen>
  );
};

ProductsView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('products'),
)(ProductsView);
